import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 md:py-20" data-id="element-104" data-mp="1lc1xz6j6wro0">
      <div className="mx-auto max-w-2xl" data-id="element-105" data-mp="1gdqowy0pyl6u">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-106" data-mp="1gaurdass9yix">
          ❓ Frequently asked questions
        </h2>

        <ul className="mt-9 space-y-3" data-id="element-107" data-mp="292o7l28uek04">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} className="overflow-hidden rounded-2xl border border-ink/10 bg-white" data-id="element-108" data-mp="1z3750tow0m8d" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-cream" data-id="element-109" data-mp="sn3gmbmw5tjr">
                  <span className="text-[15px] font-bold leading-snug text-ink" data-id="element-110" data-mp="ufzly9dqy97h">{faq.q}</span>
                  {isOpen ? <MinusIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-deep" aria-hidden="true" data-id="element-111" data-mp="fji9fettmojc" /> : <PlusIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-deep" aria-hidden="true" data-id="element-112" data-mp="kko1dafnq7rt" />}
                </button>
                {isOpen && <p className="px-5 pb-5 text-[15px] leading-relaxed text-clay" data-id="element-113" data-mp="bjhkv1d0cwyk">{faq.a}</p>}
              </li>;
        })}
        </ul>

        <CtaButton className="mt-10" label="Get Resin Architect™ for $27" data-id="element-114" data-mp="1tetf5ljbr2c" />
      </div>
    </section>;
}